import {
  INCREMENT_TUTORIAL,
  SET_TUTORIAL,
  REGISTER_STEP,
  UNREGISTER_STEP,
} from '../constants/actionTypes'

const initialState = {
  tutorial: 0,
  steps: [],
}

const reducer = (state = initialState, { type, tutorial, step }) => {
  switch (type) {
    case INCREMENT_TUTORIAL: {
      const nextStep =
        state.steps
          .filter(step => step > state.tutorial)
          .sort((a, b) => b - a) // accounts for gaps where we don't have one
          .pop() || 0
      return { ...state, tutorial: nextStep }
    }
    case SET_TUTORIAL:
      return { ...state, tutorial }
    case REGISTER_STEP:
      return { ...state, steps: [...new Set(state.steps).add(step)] }
    case UNREGISTER_STEP: {
      const steps = new Set(state.steps)
      steps.delete(step)
      return { ...state, steps: [...steps] }
    }
    default:
      return state
  }
}

export default reducer
export { initialState }
